import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { InternalServerErrorContainer } from './Style';
import { Link } from 'react-router-dom';
import background from '../../../Assets/images/background.svg';

const InternalServerError: React.FunctionComponent = (): JSX.Element => {
  const { t } = useTranslation();
  const style = {
    backgroundImage: `url(${background})`,
    backgroundSize: 'cover',
    backgroundPositionY: 'center',
    backgroundPositionX: 'center',
    backgroundAttachment: 'fixed',
    minHeight: 'calc(100vh - 62px)',
  };

  return (
    <InternalServerErrorContainer style={style}>
      <div>
        <h1>500</h1>
        <h2>{t('Sorry, the server cannot show this page')}</h2>
        <Link to="/courses">{t('Go to courses page')}</Link>
      </div>
    </InternalServerErrorContainer>
  );
};

export default InternalServerError;
